import { GET_SUPPORT_ITEM_TYPES } from "constants/supportItemTypes";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SUPPORT_ITEM_TYPES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
